import React from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "../css/RealTimeBarChart.css";

/**
 * Props:
 *  - data: array of { state, total_employees, punched_employees }
 */
const StateVsPunchedEmployees = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return <div style={{ padding: 20 }}>No punched employee data available</div>;
  }

  const labels = data.map((d) => d.state);
  const totalEmployees = data.map((d) => d.total_employees ?? 0);
  const punchedEmployees = data.map((d) => d.punched_employees ?? 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Total Employees",
        data: totalEmployees,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "Punched Employees",
        data: punchedEmployees,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
    ],
  };

  return (
    <div className="chart-container">
      <div className="chartdiv" style={{ height: 360 }}>
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { position: "top" },
              title: { display: true, text: "State Vs Punched Employee" },
            },
            scales: {
              x: { ticks: { autoSkip: false, maxRotation: 90, minRotation: 90 } },
              y: { beginAtZero: true },
            },
          }}
        />
      </div>
    </div>
  );
};

export default StateVsPunchedEmployees;
